import { BasicCard } from "./widgets";
import LoadingPane from './loading-pane';
import ValidationError from './validation-error';
import RequiredIndicator from './required-indicator';
import RequiredLabel from './required-label';
import RequiredLegend from './required-legend';
import GenericError from './generic-error';
import ModalWindow from './modal-window';
import ConfirmModalWindow from './confirm-modal-window';
import TabsComponent from './tabs.component';
import PagedList from './paged-list';
import PagingControl from './paging-control';
import SaveButton from './save-button';
import InlineWarning from './inline-warning';
import { TooltipDisplay } from './tooltip-display';
import InlineWarningList from './inline-warning-list';
import RequirePermissions from './require-permissions';
import { AccessibilityNotificationComponent, accessibilityNotificationsActions,
  accessibilityNotificationReducer, accessibilityNotificationsEmitter } from './accessibility-notifications';
import * as formPermissionsHelpers from './form-permissions-helpers';
import * as formElements from './form-elements';
import * as dateUtilities from './date-utilities';
import * as errorUtilities from './error-utilities';
import * as emailUtilities from './email-utilities';
import * as pagingDataUtilities from './paging';
import * as numberUtils from './number-utils';
import * as pagedListUtilities from './paged-list-utils';
import * as ssgFormsAdapters from './ssg-forms-adapters';
import { settingsReducer } from './settings';
import * as passwordUtilities from './password-utilities';
import * as formSaveHelpers from './form-save-helpers';
import { TimerComponent } from './timer-component';
import { LegalSection } from "./legal-section";

function isNullOrUndefined(arg) {
  return arg === null || arg === undefined;
}

export {
  BasicCard,
  isNullOrUndefined,
  LoadingPane,
  ValidationError,
  RequiredIndicator,
  RequiredLabel,
  RequiredLegend,
  GenericError,
  ModalWindow,
  ConfirmModalWindow,
  TabsComponent,
  PagedList,
  PagingControl,
  SaveButton,
  InlineWarning,
  InlineWarningList,
  TooltipDisplay,
  TimerComponent,
  LegalSection,
  formElements,
  dateUtilities,
  errorUtilities,
  emailUtilities,
  pagingDataUtilities,
  settingsReducer,
  passwordUtilities,
  numberUtils,
  RequirePermissions,
  formPermissionsHelpers,
  pagedListUtilities,
  AccessibilityNotificationComponent,
  accessibilityNotificationsActions,
  accessibilityNotificationReducer,
  accessibilityNotificationsEmitter,
  ssgFormsAdapters,
  formSaveHelpers,
}



// WEBPACK FOOTER //
// src/common/index.js